module.exports = __webpack_public_path__ + "static/media/ar.b1305065.jpeg";